import { SortDirection } from '../models/global';

export const buildOrderData = ({
  orderBy: orderByInput,
  sortDirection: sortDirectionInput,
  tableMap,
}: {
  orderBy?: string;
  sortDirection?: SortDirection;
  tableMap: Map<string, string>;
}) => {
  const orderBy = tableMap.get(orderByInput);
  const sortDirection = sortDirectionInput.toUpperCase() as SortDirection;

  if (!orderBy || !['ASC', 'DESC'].includes(sortDirection)) {
    return null;
  }
  return { orderBy, sortDirection };
};

export const buildParams = ({
  limit,
  page,
  orderData,
  regionFilter,
  countryFilter,
}: {
  limit: number;
  page: number;
  orderData?: { orderBy: string; sortDirection: string } | null;
  regionFilter?: { id: string };
  countryFilter?: { id: string };
}) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
    ...(orderData && orderData),
    ...(regionFilter && { region: regionFilter.id }),
    ...(countryFilter && { country: countryFilter.id }),
  });
  return `?${params.toString()}`;
};

export const buildColumns = (tableMap: Map<string, string>) => {
  const columns = Array.from(tableMap.keys());
  const rowsUnsortable = Array.from(tableMap.keys()).filter(key => !tableMap.get(key));
  return { columns, rowsUnsortable };
};
